import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { authenticationCss } from "./authentication.css";
import { Button } from "primereact/button";
import { set, useForm } from "react-hook-form";
import { Loader } from "../../../../Components";
import { AuthContext } from "../../../../Context/AuthContext";
import { BtnUploadFile } from "./components/BtnUploadFile";
import axios from "axios";
import { url } from "../../../../env";
import { References } from "./components/References";
import { myResolver } from "./resolver";
import { pasosDe, primerGrupoQueFalta } from "./pasosDocumentos";
import { CsFAndAddress } from "./components/CsfAndAddress";

function Authentication({ setPageStep3, pageStep3, show, setStep }) {

    // Con retomaBot (lead del bot) se pinta solo el primer grupo que falta; sin la señal, todo como siempre.
    const retomaBot = pageStep3.retomaBot === true;
    const docs = pageStep3.uploadDocuments;
    const pasoDerivado = primerGrupoQueFalta(pasosDe(pageStep3.selectedTypePerson), docs); // equivale al stepInitial de antes
    const currentStep = useRef(pasoDerivado);
    if (retomaBot) currentStep.current = pasoDerivado;
    const mostrar = (paso, condicionDeHoy) => (retomaBot ? pasoDerivado === paso : condicionDeHoy);

    const [files, setFiles] = useState({
        edosCta: [
            { ref: React.createRef(), file: null, charged: "Cargar", isCharged: false, previewUrl: null, label: "", required: true },
            { ref: React.createRef(), file: null, charged: "Cargar", isCharged: false, previewUrl: null, label: "", required: true },
            { ref: React.createRef(), file: null, charged: "Cargar", isCharged: false, previewUrl: null, label: "", required: true },
        ],
        csf: [
            { ref: React.createRef(), file: null, charged: "Cargar", isCharged: false, previewUrl: null, label: "", required: true },
        ],
        address: [
            { ref: React.createRef(), file: null, charged: "Cargar", isCharged: false, previewUrl: null, label: "operativo", required: true },
            { ref: React.createRef(), file: null, charged: "Cargar", isCharged: false, previewUrl: null, label: "fiscal", required: true },
        ],
        actaRppPoderes: [
            { ref: React.createRef(), file: null, charged: "Cargar", isCharged: false, previewUrl: null, label: "acta constitutiva", required: true },
            { ref: React.createRef(), file: null, charged: "Cargar", isCharged: false, previewUrl: null, label: "actaRpp", required: true },
            { ref: React.createRef(), file: null, charged: "Cargar", isCharged: false, previewUrl: null, label: "poderes", required: true },
        ],
        edosFinancieros: [
            { ref: React.createRef(), file: null, charged: "Cargar", isCharged: false, previewUrl: null, label: "Ultimo anual", required: true },
            { ref: React.createRef(), file: null, charged: "Cargar", isCharged: false, previewUrl: null, label: "Ultimo parcial", required: true },
            { ref: React.createRef(), file: null, charged: "Cargar", isCharged: false, previewUrl: null, label: "Balanza comprobacion parcial", required: true },
        ],
        edosCtaAval: [
            { ref: React.createRef(), file: null, charged: "Cargar", isCharged: false, previewUrl: null, label: "edos cuenta RL", required: true },
            { ref: React.createRef(), file: null, charged: "Cargar", isCharged: false, previewUrl: null, label: "edos cuenta RL", required: true },
            { ref: React.createRef(), file: null, charged: "Cargar", isCharged: false, previewUrl: null, label: "edos cuenta RL", required: true },
        ],
        addressAval: [
            { ref: React.createRef(), file: null, charged: "Cargar", isCharged: false, previewUrl: null, label: "Comprobante RL", required: true },
        ],
        identifications: [
            { ref: React.createRef(), file: null, charged: "Cargar", isCharged: false, previewUrl: null, label: "Identificación oficial", required: true },
        ],
    });


    useEffect(() => {
        // Define la cantidad de archivos según selectedTypePerson
        const fileCount = pageStep3.selectedTypePerson === 2 ? 3 : 6;

        // Actualiza el número de archivos en edosCta
        setFiles(prevFiles => {
            const updatedEdosCta = prevFiles.edosCta.slice(0, fileCount); // Mantén solo la cantidad requerida
            // Si necesitamos más archivos, agrega objetos de archivo adicionales
            while (updatedEdosCta.length < fileCount) {
                updatedEdosCta.push({
                    ref: React.createRef(), // Usar createRef en lugar de useRef
                    file: null,
                    charged: "Cargar",
                    isCharged: false,
                    previewUrl: null,
                    required: true,
                });
            }

            return {
                ...prevFiles,
                edosCta: updatedEdosCta,
            };
        });
    }, [pageStep3.selectedTypePerson]);


    // console.log(authInfo, "authInfoauthInfo", secret);
    const defaultValues = useMemo(() => ({
        rfc: null,
        password: null,
        confirmPassword: null,
        confirmRfc: null,
        checkConfirm: false,
        rf1_nombre: null, rf1_apellidoP: null, rf1_apellidoM: null,
        rf2_nombre: null, rf2_apellidoP: null, rf2_apellidoM: null,
        rf3_nombre: null, rf3_apellidoP: null, rf3_apellidoM: null,
        parent1: null,
        tel1: null,
        parent2: null,
        tel2: null,
        parent3: null,
        tel3: null,
        edosCta: files.edosCta.map(file => file),
        csf: files.csf.map(file => file.file),
        address: files.address.map(file => file),
        identifications: files.identifications.map(file => file),
        // data for typePerson === 2 = moral
        ...(pageStep3.selectedTypePerson === 2 && {
            actaRppPoderes: files.actaRppPoderes.map(file => file),
            edosFinancieros: files.edosFinancieros.map(file => file),
            edosCtaAval: files.edosCtaAval.map(file => file),
            addressAval: files.addressAval.map(file => file),
        })
    }), [files]);


    const {
        register,
        handleSubmit,
        watch,
        reset,
        formState: { errors, isDirty, isValid },
        control,
        setValue
    } = useForm({
        defaultValues,
        mode: "onChange",
        // criteriaMode: "all",
        // shouldFocusError: true,
        // shouldUnregister: true,
        resolver: (data) => myResolver(data, pageStep3), // Pasar stepsDocs aquí
    });
    const [loading, setLoading] = useState(false);



    const onError = (errors, data) => {
        // console.log('Hay errores en el formulario', errors);
        // myResolver(data,pageStep3.uploadDocuments ).then((result) => {
        //     console.log('Errores resueltos', result.errors);
        // });
        // Puedes manejar los errores aquí
    };

    const handleFormSubmit = async (data, event) => {
        // Llama a tu resolver de manera manual antes de proceder
        const result = await myResolver(data, pageStep3);

        if (Object.keys(result.errors).length === 0) {
            // Si no hay errores, envía los datos
            submit(data);
        } else {
            // Si hay errores, maneja esos errores
            onError(result.errors, data);
        }
    };



    const makeRequest = async (url, formData) => {
        try {
            const result = await axios.post(url, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            });
            return result.status === 201;
        } catch (error) {
            const errorInfo = error.response ? error.response.data : error.response.data.error ? error.response.data.error : "Error"
            show('error', `Error al guardar el archivo: ${errorInfo}`, 'Error');
            return false;
        } finally {
            setLoading(false);
        }
    };

    const generateUploadFiles = async (filesData, name, typePerson) => {
        const res = await axios.post(url + '/generate-upload-urls', {
            files: filesData,
            name: name,
            typePerson: typePerson,
        }, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("token")}`,
            },

        });
        const data = res.data;
        return data;
    };

    const uploadFileToS3 = async (file, presignedUrl, attempt = 1, maxRetries = 3) => {
        try {
            const response = await axios.put(presignedUrl, file, {
                headers: { "Content-Type": file.type },
                onUploadProgress: (progressEvent) => {
                    const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    // show('info', `Subiendo ${file.name}: ${percent}%`, 'Progreso de subida');
                },
                timeout: 30000,
            });

            if (response.status === 200) {
                show('success', `Subida de ${file.name} completada con éxito.`, 'Éxito');
            } else {
                throw new Error(`Estado inesperado al subir ${file.name}`);
            }

        } catch (error) {
            if (attempt < maxRetries) {
                console.warn(`Reintentando subir ${file.name}, intento #${attempt + 1} de ${maxRetries}`);
                return await uploadFileToS3(file, presignedUrl, attempt + 1, maxRetries);
            } else {
                // Mostrar error y lanzar para detener ejecución
                const message = error?.response?.statusText || error?.message || 'Error desconocido';

                show('error', `Falló la subida de ${file.name} después de ${maxRetries} intentos`, 'Error');

                throw new Error(`Subida fallida para ${file.name}`);
            }
        }
    };



    const uploadFilesSequentially = async (files, presignedUrls, name) => {
        try {
            for (const { url, original } of presignedUrls) {
                const fileEntry = files.find(f => {
                    if (f instanceof File) {
                        return f.name === original;
                    } else if (f.file instanceof File) {
                        return f.file.name === original;
                    }
                    return false;
                });

                const file = fileEntry instanceof File ? fileEntry : fileEntry?.file;

                if (file) {
                    await uploadFileToS3(file, url);
                } else {
                    show('error', `Archivo no encontrado: ${original}`, 'Error');
                    throw new Error(`Archivo no encontrado: ${original}`);
                }
            }

            //   show('success', 'Todos los archivos se subieron correctamente.', 'Completado');

            //informar a la base de datos que se subieron los archivos
            //enviar paths y nombre de la sección
            let newUrl = ""
            if (name === "address" || name === "actaRppPoderes" || name === "addressAval") {
                newUrl = `${url}/leasing/uploadFilesAddress`;
            } else {
                newUrl = `${url}/leasing/UploadFiles`;
            }


            const result = await makeRequest(newUrl, {
                name: name,
                typePerson: pageStep3.selectedTypePerson,
                files: presignedUrls.map(item => item.key)
            });
            if (result) {
                return true;

            }



        } catch (error) {
            show('error', `Proceso detenido: ${error.message}`, 'Subida cancelada');
            // Aquí podrías manejar lógica adicional como rollback o reset de estado
        }
    };




    // const uploadFileToS3 = async (file, presignedUrl) => {
    //     await axios.put(presignedUrl, file, {
    //         headers: {
    //             "Content-Type": file.type,
    //             // "Authorization": `Bearer ${localStorage.getItem("token")}`,
    //         },
    //     });
    // };


    const handleStep = async (step, data) => {
        let success = false;
        switch (step) {
            case "edosCta": {
                setLoading(true);

                const formData = new FormData();
                data.edosCta.forEach((file, index) => {
                    if (file.file) {
                        formData.append(`edosCta${index + 1}`, file.file);
                    }
                });
                formData.append("typePerson", pageStep3.selectedTypePerson);
                formData.append("name", "edosCta");

                const files = data.edosCta
                    .filter(item => item.file)
                    .map(item => item.file); // Aquí tenemos solo los File

                const filesData = files.map(file => ({
                    filename: file.name,
                    type: file.type,
                }));

                const presignedUrls = await generateUploadFiles(filesData, "edosCta", pageStep3.selectedTypePerson);

                const success = await uploadFilesSequentially(files, presignedUrls, "edosCta");


                // success = await makeRequest(`${url}/leasing/UploadFiles`, formData);

                if (success) {
                    setPageStep3(prev => ({
                        ...prev,
                        uploadDocuments: { ...prev.uploadDocuments, edosCta: true }
                    }));
                    show('success', 'Información enviada correctamente.', 'Éxito');
                    setLoading(false);
                    currentStep.current = "address";
                }
                break;
            }

            case "address": {
                setLoading(true);

                // if (!data.address[0] || !data.address[1]) return false;
                if (!data.address[0].file && !data.address[1].file) return false;



                const formData = new FormData();
                data.address.forEach((file, index) => {
                    if (file.file) {
                        formData.append(`address${index + 1}`, file.file);
                    }
                });
                formData.append("typePerson", pageStep3.selectedTypePerson);
                formData.append("name", "address");

                const files = data.address
                    .filter(item => item.file)
                    .map(item => ({
                        file: item.file,
                        label: item.label,
                    }));


                const filesData = files.map(file => ({
                    filename: file.file.name,
                    type: file.file.type,
                    label: file.label,
                }));


                const presignedUrls = await generateUploadFiles(filesData, "address", pageStep3.selectedTypePerson);

                const success = await uploadFilesSequentially(files, presignedUrls, "address");

                // success = await makeRequest(`${url}/leasing/uploadFilesAddress`, formData);

                if (success) {
                    setPageStep3(prev => ({
                        ...prev,
                        uploadDocuments: { ...prev.uploadDocuments, address: true }
                    }));
                    show('success', 'Información enviada correctamente.', 'Éxito');
                    setLoading(false);
                    if (pageStep3.selectedTypePerson === 2) {
                        currentStep.current = "actaRppPoderes";
                        return
                    }
                    currentStep.current = "references";
                }
                break;
            }

            case "references": {
                setLoading(true);

                const joinName = (n) =>
                    [data[`rf${n}_nombre`], data[`rf${n}_apellidoP`], data[`rf${n}_apellidoM`]]
                        .filter(Boolean).join(" ").trim();
                data.rf1 = joinName(1);
                data.rf2 = joinName(2);
                data.rf3 = joinName(3);

                if (!data.rf1 || !data.rf2 || !data.rf3) return false;

                const formData = new FormData();
                ['rf1', 'parent1', 'tel1', 'rf2', 'parent2', 'tel2', 'rf3', 'parent3', 'tel3'].forEach(key => {
                    formData.append(key, data[key]);
                });
                formData.append("typePerson", pageStep3.selectedTypePerson);

                success = await makeRequest(`${url}/leasing/uploadReferences`, formData);
                if (success) {
                    setPageStep3(prev => ({
                        ...prev,
                        uploadDocuments: { ...prev.uploadDocuments, reference: true }
                    }));
                    // success = await makeRequest(`${url}/leasing/uploadReferences`, formData);

                    show('success', 'Información enviada correctamente.', 'Éxito');
                    setLoading(false);
                    currentStep.current = "identifications";
                    // setStep(4)
                }
                break;
            }
            case "actaRppPoderes": {
                setLoading(true);

                if (!data.actaRppPoderes[0].file) return false;
                const formData = new FormData();
                data.actaRppPoderes.forEach((file, index) => {
                    if (file.file) {
                        const name = files.actaRppPoderes[index].label ? files.actaRppPoderes[index].label : `actaRppPoderes${index + 1}`;
                        formData.append(`${name}`, file.file);
                    }
                });
                formData.append("name", "actaRppPoderes");

                const filess = data.actaRppPoderes
                    .filter(item => item.file)
                    .map(item => ({
                        file: item.file,
                        label: item.label,
                    }));

                const filesData = filess.map(file => ({
                    filename: file.file.name,
                    type: file.file.type,
                    label: file.label,
                }));

                const presignedUrls = await generateUploadFiles(filesData, "actaRppPoderes", pageStep3.selectedTypePerson);

                const success = await uploadFilesSequentially(filess, presignedUrls, "actaRppPoderes");

                // success = await makeRequest(`${url}/leasing/uploadFilesAddress`, formData, "actaRppPoderes");


                if (success) {
                    setPageStep3(prev => ({
                        ...prev,
                        uploadDocuments: { ...prev.uploadDocuments, actaRppPoderes: true }
                    }));
                    show('success', 'Información enviada correctamente.', 'Éxito');
                    setLoading(false);
                    currentStep.current = "edosFinancieros";

                }

                // const formData = new FormData();
            }

            case "edosFinancieros": {

                // if (!data.edosFinancieros[0] || !data.edosFinancieros[1] || !data.edosFinancieros[2]) return false;
                if (!data.edosFinancieros[0].file) return false;
                setLoading(true);

                const formData = new FormData();
                data.edosFinancieros.forEach((file, index) => {
                    if (file.file) {
                        formData.append(`edosFinancieros${index + 1}`, file.file);
                    }
                });
                formData.append("typePerson", pageStep3.selectedTypePerson);
                formData.append("name", "edosFinancieros");

                const files = data.edosFinancieros
                    .filter(item => item.file)
                    .map(item => item.file); // Aquí tenemos solo los File

                const filesData = files.map(file => ({
                    filename: file.name,
                    type: file.type,
                }));
                const presignedUrls = await generateUploadFiles(filesData, "edosFinancieros", pageStep3.selectedTypePerson);
                const success = await uploadFilesSequentially(files, presignedUrls, "edosFinancieros");

                if (success) {
                    setPageStep3(prev => ({
                        ...prev,
                        uploadDocuments: { ...prev.uploadDocuments, edosFinancieros: true }
                    }));
                    show('success', 'Información enviada correctamente.', 'Éxito');
                    setLoading(false);

                    currentStep.current = "edosCtaAval";

                }
            }
            case "edosCtaAval": {
                if (!data.edosCtaAval || !data.edosCtaAval.every(item => item.file)) return false;
                setLoading(true);

                const formData = new FormData();
                data.edosCtaAval.forEach((file, index) => {
                    if (file.file) {
                        formData.append(`edosCtaAval${index + 1}`, file.file);
                    }
                });
                // data.addressAval.forEach((file, index) => {
                //     formData.append(`addressAval${index + 1}`, file);
                // });
                formData.append("typePerson", pageStep3.selectedTypePerson);
                formData.append("name", "edosCtaAval");

                const files = data.edosCtaAval
                    .filter(item => item.file)
                    .map(item => item.file); // Aquí tenemos solo los File

                const filesData = files.map(file => ({
                    filename: file.name,
                    type: file.type,
                }));

                const presignedUrls = await generateUploadFiles(filesData, "edosCtaAval", pageStep3.selectedTypePerson);
                const success = await uploadFilesSequentially(files, presignedUrls, "edosCtaAval");
                // success = await makeRequest(`${url}/leasing/UploadFiles`, formData);
                if (success) {
                    setPageStep3(prev => ({
                        ...prev,
                        uploadDocuments: { ...prev.uploadDocuments, edosCtaAval: true }
                    }));
                    show('success', 'Información enviada correctamente.', 'Éxito');
                    setLoading(false);

                    // currentStep.current = "addressAval";
                    if (!data.addressAval[0].file) return false;
                    setLoading(true);
                    const formData = new FormData();
                    data.addressAval.forEach((file, index) => {
                        formData.append(`addressAval${index + 1}`, file.file);
                    });
                    formData.append("typePerson", pageStep3.selectedTypePerson);
                    formData.append("name", "addressAval");

                    const files = data.addressAval
                        .filter(item => item.file)
                        .map(item => ({
                            file: item.file,
                            label: item.label,
                        }));


                    const filesData = files.map(file => ({
                        filename: file.file.name,
                        type: file.file.type,
                        label: file.label,
                    }));

                    const presignedUrls = await generateUploadFiles(filesData, "addressAval", pageStep3.selectedTypePerson);
                    const success = await uploadFilesSequentially(files, presignedUrls, "addressAval");


                    // success = await makeRequest(`${url}/leasing/uploadFilesAddress`, formData,);
                    if (success) {

                        setPageStep3(prev => ({
                            ...prev,
                            uploadDocuments: { ...prev.uploadDocuments, addressAval: true }
                        }));

                        show('success', 'Información enviada correctamente.', 'Éxito')
                        setLoading(false);
                        currentStep.current = "identifications";
                        break;
                    }
                }
                // const formData = new FormData();
            }
            case "addressAval": {
                if (!data.addressAval[0] && !pageStep3.uploadDocuments.edosCtaAval) return false;
                setLoading(true);
                const formData = new FormData();
                data.addressAval.forEach((file, index) => {
                    formData.append(`addressAval${index + 1}`, file.file);
                });
                formData.append("typePerson", pageStep3.selectedTypePerson);
                formData.append("name", "addressAval");
                const files = data.addressAval
                    .filter(item => item.file)
                    .map(item => ({
                        file: item.file,
                        label: item.label,
                    }));


                const filesData = files.map(file => ({
                    filename: file.file.name,
                    type: file.file.type,
                    label: file.label,
                }));

                const presignedUrls = await generateUploadFiles(filesData, "addressAval", pageStep3.selectedTypePerson);
                const success = await uploadFilesSequentially(files, presignedUrls, "addressAval");
                // success = await makeRequest(`${url}/leasing/uploadFilesAddress`, formData,);
                if (success) {
                    setPageStep3(prev => ({
                        ...prev,
                        uploadDocuments: { ...prev.uploadDocuments, addressAval: true }
                    }));
                    show('success', 'Información enviada correctamente.', 'Éxito');
                    setLoading(false);
                    currentStep.current = "identifications";
                    break;
                }

                // const formData = new FormData();
            }

            case "identifications": {
                if (!data.identifications[0].file) return false;
                setLoading(true);

                const formData = new FormData();
                data.identifications.forEach((file, index) => {
                    if (file.file) {
                        formData.append(`identifications${index + 1}`, file.file);
                    }
                });
                formData.append("typePerson", pageStep3.selectedTypePerson);
                formData.append("name", "identifications");
                formData.append("isFinal", true);

                const files = data.identifications
                    .filter(item => item.file)
                    .map(item => item.file); // Aquí tenemos solo los File

                const filesData = files.map(file => ({
                    filename: file.name,
                    type: file.type,
                }));

                const presignedUrls = await generateUploadFiles(filesData, "identifications", pageStep3.selectedTypePerson);
                const success = await uploadFilesSequentially(files, presignedUrls, "identifications");


                // success = await makeRequest(`${url}/leasing/UploadFiles`, formData);

                if (success) {
                    setPageStep3(prev => ({
                        ...prev,
                        uploadDocuments: { ...prev.uploadDocuments, identifications: true }
                    }));
                    show('success', 'Información enviada correctamente.', 'Éxito');
                    setLoading(false);
                    currentStep.current = "ok";
                }
                break;
            }
            default:
                show('error', 'Paso no reconocido.', 'Error');
                return false;
        }

        return success;
    };

    const submit = async (data) => {
        const steps = ["edosCta", "address",];
        if (pageStep3.selectedTypePerson === 2) {
            steps.push("actaRppPoderes", "edosFinancieros", "edosCtaAval", "addressAval", "identifications");
        } else {
            steps.push("references", "identifications");
        }
        for (const step of steps) {
            if (currentStep.current === step) {
                const success = await handleStep(step, data);
                if (success) {
                    const index = steps.indexOf(step);
                    currentStep.current = steps[index + 1] || "ok";
                    break;
                } else {
                    break;
                }
            }
        }
    };


    useEffect(() => {
        setValue("edosCta", files.edosCta.map(file => file), { shouldValidate: true });
        // setValue("csf", files.csf.map(file => file.file), { shouldValidate: true });
        setValue("address", files.address.map(file => file), { shouldValidate: true });
        setValue("identifications", files.identifications.map(file => file), { shouldValidate: true });
        if (pageStep3.selectedTypePerson === 2) { //persona moral
            setValue("actaRppPoderes", files.actaRppPoderes.map(file => file), { shouldValidate: true });
            setValue("edosFinancieros", files.edosFinancieros.map(file => file), { shouldValidate: true });
            setValue("edosCtaAval", files.edosCtaAval.map(file => file), { shouldValidate: true });
            setValue("addressAval", files.addressAval.map(file => file), { shouldValidate: true });
        }
    }, [files, setValue]);

    const typePerson = pageStep3.selectedTypePerson

    useEffect(() => {
        if (currentStep.current == "ok") {
            setStep(4)
        }
    }, [currentStep.current])

    const addNewFileInTheList = (name, label = "extra") => {
        const newFiles = [...files[name]];
        newFiles.push({
            ref: React.createRef(),
            file: null,
            charged: "Cargar",
            label: "extra",
            isCharged: false,
            previewUrl: null,
        });
        setFiles(prev => ({
            ...prev,
            [name]: newFiles
        }));
    }


    const deleteFileInTheList = (name, index) => {
        setFiles(prev => {
            const newFiles = [...prev[name]];
            if (newFiles[index].previewUrl) {
                URL.revokeObjectURL(newFiles[index].previewUrl);
            }
            newFiles.splice(index, 1);
            return {
                ...prev,
                [name]: newFiles
            }
        })
    };



    return (
        <div css={authenticationCss()}>
            {loading &&
                <div style={{
                    zIndex: 1000,
                }}>
                    <Loader msg="Este paso puede tardar unos minutos, por favor no cierres la ventana." />
                </div>
            }
            <div className="Background" />

            {/* <Button
                label="Regresar"
                className="Green py-3"
                onClick={() => setPageStep3(0)}
            /> */}
            <div className="TopText">Estas a un paso de estrenar tu coche.</div>

            <div className="flex flex-column align-items-center FormContainer">

                {/* <form className="grid" onSubmit={handleSubmit((data) => submit(data))}>
                 */}
                <form className="grid" onSubmit={handleSubmit(handleFormSubmit)}>

                    {/* Renderizado para persona física (PFAE o PF) */}
                    {(pageStep3.selectedTypePerson === 1 || pageStep3.selectedTypePerson === 3) && (
                        <>
                            {mostrar("edosCta", !pageStep3.uploadDocuments.edosCta) && (
                                <div className="section-upload-status flex">
                                    <div className="TopText2 pt-6">

                                        <span className='NormalText'>Carga los últimos 6 estados de cuenta completos (todas las hojas).</span>

                                    </div>
                                    <div className="col-12 p-2">
                                        <BtnUploadFile files={files.edosCta} setFiles={setFiles} name="edosCta" typePerson={typePerson} show={show} errors={errors} addNewFileInTheList={addNewFileInTheList} deleteFileInTheList={deleteFileInTheList} />
                                    </div>
                                </div>
                            )}
                            {mostrar("address", pageStep3.uploadDocuments.edosCta && !pageStep3.uploadDocuments.address) && (
                                <>
                                    <CsFAndAddress register={register} files={files.address} setFiles={setFiles} name="address"
                                        typePerson={typePerson} show={show} errors={errors} addNewFileInTheList={addNewFileInTheList} deleteFileInTheList={deleteFileInTheList} />
                                </>
                            )}
                            {mostrar("references", pageStep3.uploadDocuments.address && !pageStep3.uploadDocuments.reference) && (
                                <References register={register} errors={errors} control={control} />
                            )}

                            {mostrar("identifications", pageStep3.uploadDocuments.reference && !pageStep3.uploadDocuments.identifications) && (
                                <div className="section-upload-status flex">
                                    <div className="TopText2 pt-6"
                                        style={{
                                            width: "100%",
                                            textAlign: "center",
                                            fontWeight: "400",

                                        }}
                                    >

                                        <span className='NormalText'>Felicidades, has completado la carga de documentos. </span>
                                        <br />
                                        <span className='NormalText'> Ahora por ultimo, carga tu identificación oficial (INE, Pasaporte, Licencia de conducir).</span>

                                    </div>
                                    <div className="col-12 p-2">
                                        <BtnUploadFile files={files.identifications} setFiles={setFiles} name="identifications" typePerson={typePerson} show={show} errors={errors} addNewFileInTheList={addNewFileInTheList} deleteFileInTheList={deleteFileInTheList} />
                                    </div>
                                </div>
                            )}

                        </>
                    )}

                    {/* Renderizado para selectedTypePerson distinto de 1 */}
                    {pageStep3.selectedTypePerson == 2 && (
                        <>
                            {mostrar("edosCta", !pageStep3.uploadDocuments.edosCta) && (
                                <div className="section-upload-status flex">
                                    <div className="TopText2 pt-6  w-full"
                                        style={{
                                            width: "100%",
                                            textAlign: "center"
                                        }}
                                    >
                                        <span className="NormalText"
                                            style={{
                                                textAlign: "center",
                                                fontWeight: "400",
                                            }}
                                        >
                                            Carga los últimos 3 estados de cuenta completos (todas las hojas).
                                        </span>
                                    </div>
                                    <div className="col-12 p-2">
                                        <BtnUploadFile files={files.edosCta} setFiles={setFiles} name="edosCta" typePerson={typePerson} show={show} errors={errors} addNewFileInTheList={addNewFileInTheList} deleteFileInTheList={deleteFileInTheList} />
                                    </div>
                                </div>
                            )}
                            {mostrar("address", pageStep3.uploadDocuments.edosCta && !pageStep3.uploadDocuments.address) && (
                                <CsFAndAddress register={register} files={files.address} setFiles={setFiles} name="address"
                                    typePerson={typePerson} show={show} errors={errors} addNewFileInTheList={addNewFileInTheList} deleteFileInTheList={deleteFileInTheList} />
                            )}
                            {mostrar("actaRppPoderes", pageStep3.uploadDocuments.address && !pageStep3.uploadDocuments.actaRppPoderes) && (
                                <CsFAndAddress register={register} files={files.actaRppPoderes} setFiles={setFiles} name="actaRppPoderes"
                                    typePerson={typePerson} show={show} errors={errors} addNewFileInTheList={addNewFileInTheList} deleteFileInTheList={deleteFileInTheList} />
                            )}
                            {mostrar("edosFinancieros", pageStep3.uploadDocuments.actaRppPoderes && !pageStep3.uploadDocuments.edosFinancieros) && (
                                <CsFAndAddress register={register} files={files.edosFinancieros} setFiles={setFiles} name="edosFinancieros"
                                    typePerson={typePerson} show={show} errors={errors} addNewFileInTheList={addNewFileInTheList} deleteFileInTheList={deleteFileInTheList} />
                            )}
                            {mostrar("edosCtaAval", pageStep3.uploadDocuments.edosFinancieros && !pageStep3.uploadDocuments.edosCtaAval) && (
                                <>
                                    <CsFAndAddress register={register} files={files.edosCtaAval} setFiles={setFiles} name="edosCtaAval"
                                        typePerson={typePerson} show={show} errors={errors} addNewFileInTheList={addNewFileInTheList} deleteFileInTheList={deleteFileInTheList} />
                                    {!(retomaBot && docs.addressAval) && (
                                    <CsFAndAddress register={register} files={files.addressAval} setFiles={setFiles} name="addressAval"
                                        typePerson={typePerson} show={show} errors={errors} addNewFileInTheList={addNewFileInTheList} deleteFileInTheList={deleteFileInTheList} />
                                    )}

                                </>
                            )}
                            {mostrar("addressAval", pageStep3.uploadDocuments.edosCtaAval && !pageStep3.uploadDocuments.addressAval) && (
                                <CsFAndAddress register={register} files={files.addressAval} setFiles={setFiles} name="addressAval"
                                    typePerson={typePerson} show={show} errors={errors} addNewFileInTheList={addNewFileInTheList} deleteFileInTheList={deleteFileInTheList} />
                            )}
                            {mostrar("identifications", pageStep3.uploadDocuments.addressAval && !pageStep3.uploadDocuments.identifications) && (
                                <div className="section-upload-status flex">
                                    <div className="TopText2 pt-6 w-full"
                                        style={{
                                            width: "100%",
                                            textAlign: "center"
                                        }}
                                    >

                                        <span className='NormalText'
                                            style={{
                                                fontWeight: "400",
                                            }}
                                        >Has completado la carga de documentos.</span>
                                        <br />
                                        <span className='NormalText'
                                            style={{
                                                fontWeight: "400",
                                                textAlign: "center"
                                            }}
                                        >Por ultimo, carga tu identificación oficial (INE, Pasaporte, Licencia de conducir).</span>

                                    </div>
                                    <div className="col-12 p-2">
                                        <BtnUploadFile files={files.identifications} setFiles={setFiles} name="identifications" typePerson={typePerson} show={show} errors={errors} addNewFileInTheList={addNewFileInTheList} deleteFileInTheList={deleteFileInTheList} />
                                    </div>
                                </div>
                            )}


                        </>
                    )}



                    {/* {pageStep3.uploadDocuments.reference && currentStep.current == "ok" && (
                       <div> NUFIIIIIII </div>
                    )} */}

                    <div className={`col-12 p-2 ButtonContainer `}>
                        <Button
                            label="Continuar"
                            className="w-full Green Button py-3"
                            disabled={!isValid || loading}
                            type="submit"
                        />

                    </div>
                    <div className="col-12 flex justify-content-center pt-6">
                        <div
                            className="shadowCard "
                            style={{ height: "2rem", width: "80%" }}
                        />
                    </div>
                </form>
            </div>

        </div>
    );
}

export { Authentication };



{/* 
{pageStep3.uploadDocuments.edosCtaAval && !pageStep3.uploadDocuments.addressAval && (
                                <CsFAndAddress register={register} files={files.addressAval} setFiles={setFiles} name="addressAval"
                                    typePerson={typePerson} show={show} errors={errors} />
                            )} */}